import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminDeleted_itemsConsumptions = z.any()
export type TagsGetAdminDeleted_itemsConsumptions = z.infer<typeof tagsGetAdminDeleted_itemsConsumptions>

export const responseGetAdminDeleted_itemsConsumptions = z.object({ "payload": z.array(z.object({ "id": z.string(), "number": z.string(), "collectionPoint": z.object({ "name": z.string() }), "building": z.object({ "name": z.string() }), "municipality": z.object({ "name": z.string() }), "deletedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminDeleted_itemsConsumptions = z.infer<typeof responseGetAdminDeleted_itemsConsumptions>

interface IGetAdminDeleted_itemsConsumptions extends BaseMethodType {
  tags: TagsGetAdminDeleted_itemsConsumptions,
  response: ResponseGetAdminDeleted_itemsConsumptions
}
export const URL = '/admin/deleted-items/consumptions'
export const validation = {
  get: {
    tags: tagsGetAdminDeleted_itemsConsumptions,
    response: responseGetAdminDeleted_itemsConsumptions
  }
}
export interface AdminDeleted_itemsConsumptions extends BaseRouteType {
  get: IGetAdminDeleted_itemsConsumptions
}